import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
  Chip
} from '@mui/material';
import api from '../../api/axios';

const AssignSubscription = () => {

  const [companies, setCompanies] = useState([]);
  const [plans, setPlans] = useState([]);
  const [companyId, setCompanyId] = useState('');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    loadCompanies();
    loadPlans();
  }, []);

  const loadCompanies = async () => {
    try {
      const res = await api.get('/super-admin/companies');
      setCompanies(res.data);
    } catch (e) {}
  };

  const loadPlans = async () => {
    try {
      const res = await api.get('/super-admin/plans');
      setPlans(res.data);
    } catch (e) {}
  };

  /* ================= ASSIGN ================= */
  const assign = async () => {
    if (!companyId || !selectedPlan) {
      alert('Select company and plan');
      return;
    }

    setLoading(true);

    try {
      await api.post(`/super-admin/assign?companyId=${companyId}&planId=${selectedPlan.id}`);
      alert('Plan assigned successfully');
    } catch (e) {
      alert('Failed to assign plan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>

      <Typography variant="h4" fontWeight={800}>
        Subscription Management
      </Typography>

      {/* ================= COMPANY SELECT ================= */}
      <Paper sx={{ p: 3, mt: 3, borderRadius: 3 }}>
        <Typography fontWeight={600} mb={2}>
          Select Company
        </Typography>

        <TextField
          select
          fullWidth
          label="Company"
          value={companyId}
          onChange={(e) => setCompanyId(e.target.value)}
        >
          {companies.map(c => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>
      </Paper>

      {/* ================= PLAN CARDS ================= */}
      <Box mt={4}>
        <Typography fontWeight={700} mb={2}>
          Select Plan
        </Typography>

        <Grid container spacing={3}>
          {plans.map(plan => {

            const isSelected = selectedPlan?.id === plan.id;

            return (
              <Grid item xs={12} md={4} key={plan.id}>
                <Card
                  onClick={() => setSelectedPlan(plan)}
                  sx={{
                    cursor: 'pointer',
                    borderRadius: 4,
                    border: isSelected ? '2px solid #2563eb' : '1px solid #e5e7eb',
                    transition: '0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: 6
                    }
                  }}
                >
                  <CardContent>

                    <Typography variant="h6" fontWeight={700}>
                      {plan.name}
                    </Typography>

                    <Typography variant="h4" fontWeight={800} mt={1}>
                      ₹{plan.price}
                    </Typography>

                    <Typography color="text.secondary">
                      {plan.durationInMonths} Months
                    </Typography>

                    <Box mt={2}>
                      <Chip
                        label={
                          plan.maxEmployees === -1
                            ? 'Unlimited Employees'
                            : `${plan.maxEmployees} Employees`
                        }
                        color="primary"
                      />
                    </Box>

                    {isSelected && (
                      <Typography mt={2} color="primary" fontWeight={600}>
                        Selected
                      </Typography>
                    )}

                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* ================= ACTION ================= */}
      <Box mt={4}>
        <Button
          variant="contained"
          size="large"
          onClick={assign}
          disabled={loading}
          sx={{
            px: 6,
            py: 1.5,
            borderRadius: 3,
            fontWeight: 700
          }}
        >
          {loading ? <CircularProgress size={24} /> : 'Assign Plan'}
        </Button>
      </Box>

    </Box>
  );
};

export default AssignSubscription;